import styled from "styled-components";

import Anchor from "./Anchor";
import { HorizontalRule } from "../components/HorizontalRule";
import { LargeTitle } from "./Typography";

export interface TextBlockProps {
  title: string;
  id?: string;
  children?: any;
}

export const TextBlockWithTitle = ({ id, title, children }: TextBlockProps) => {
  return (
    <Anchor name={id}>
      <Container>
        <LargeTitle>{title}</LargeTitle>
        <SubtitleUnderline variant={"primary"} />
        {children}
      </Container>
    </Anchor>
  );
};

const Container = styled.div`
  margin-bottom: var(--spacing-xl);
`;

const SubtitleUnderline = styled(HorizontalRule)`
  height: 3px;
  width: var(--spacing-xxl);
  margin: var(--spacing-md) 0;
`;
